<template>
  <div class="marginator">
    <div class="mt-0">
      <inputBox id="timeline-input" parentType="Timeline" :parentId="null" :emitUser="tagUser" subtype="Chat" />

      <transition-group name="list">
        <div
          class="record-card"
          v-for="record in items"
          :key="record.created"
        >
          <component :is="componentLookup[record.type]" :record="record" @emitUser="emitUser"></component>
          <div v-if="record._images" class="width-full float-left pt-1 pl-5">
            <vue-picture-swipe small :items="record._images"></vue-picture-swipe>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import inputBox from "../textInput.vue";
import chat from "./message.vue";
import zone from "./zone.vue";
import diary from "./diary.vue";
import zonedelete from "./zonedelete.vue";
import trade from "./tradeOpen.vue";
import flat from "./tradeClose.vue";
import preparation from "./preparation.vue";
import axios from "axios";

export default {
  name: "PoolTimeline",
  components: {
    chat,
    trade,
    zone,
    zonedelete,
    flat,
    diary,
    preparation,
    inputBox
  },
  data() {
    return {

      tagUser: null,
      componentLookup: {
        "Trade Prepare": "preparation",
        "Trade Open": "trade",
        "Trade Close": "flat",
        "Message": "chat",
        "New Zone": "zone",
        "Deleted Zone": "zonedelete",
        "Trading Diary": "diary",
        "Trade Comment": "diary"

      },
      name: "PoolTimeline",
      componentId: 2,
      chat: "",
      items: [],
      loaded: false
    };
  },
  methods: {
    emitUser(data){
      this.tagUser = data
      setTimeout(() => {
        this.tagUser = null
      },1000)
    },
    getHistory() {
      this.$emit("loading", true);
      axios
        .post("https://tradeinpool.com:3001/api/request/timeline/", {
          method: "list"
        })
        .then(response => {
          this.items = response.data;
          this.loaded = true;
          this.$emit("loading", false);
        });
    },
    onEnter() {
      if (this.chat.length > 0) {
        this.$store
          .dispatch("addChat", {
            text: this.chat
          })
          .then(() => {
            //this.$emit("loading", false);
          })
          .catch(err => {
            alert(err);
            this.$emit("loading", false);
          });
        this.chat = "";
        //this.$emit("loading", true);
      }
    },
    replyTo(val) {
      this.chat = `${val}: `;
    }
  },
  computed: {
    trans() {
      return this.$store.getters.PoolTimelineTrans;
    },
    records() {
      return this.$store.getters.PoolTimelineData;
    }
  },
  mounted() {
    this.getHistory();
  },
  sockets: {
    TIMELINE: function(data) {
      if (data.action == "add") {
        if (this.items.length > 9) {
          this.items.pop();
        }
        this.items.unshift(data);
      }

      if (data.action == "update") {
        this.items.forEach((item, index) => {
          if (item.id == data.id) {
            this.$set(this.items, index, data);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.record-card {
  width: 100%;
  float: left;
  background-color: #333b46;
  padding: 13px 15px 7px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  font-size: 12px;
}
.record-card:nth-child(odd) {
  background: #2d3540;
}

.record-card:hover {
  background: #232a35;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.header {
  width: 100%;
}
.datetime {
  color: white;
  font-family: "Roboto", "Roboto Condensed", sans-serif;
  font-weight: bold;
  font-size: 16px;
  margin: 15px;
}

.postInput input[type="text"] {
  margin-right: 15px;
  height: 40px;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #333b47 !important;
  color: white;
  font-size: 12px;
}

input[type="text"]::placeholder {
  /* Firefox, Chrome, Opera */
  color: white;
}

input[type="text"]:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
}

input[type="text"]::-ms-input-placeholder {
  /* Microsoft Edge */
  color: white;
}
</style>
